import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import useStyles from './styles/PoliciesFormAvailablePoliciesListTableHead.styles'

const PoliciesFormAvailablePoliciesListTableHead = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableHead}>
      <div>
        <Typography variant="h5">{getTranslate('Priority')}</Typography>
      </div>
      <div>
        <Typography variant="h5">{getTranslate('Penalty Amount')}</Typography>
      </div>
      <div>
        <Typography variant="h5">{getTranslate('Penalty Type')}</Typography>
      </div>
      <div>
        <Typography variant="h5">{getTranslate('Deadline (hrs)')}</Typography>
      </div>
      <div>
        <Typography variant="h5">
          {getTranslate('Deadline Time Offset')}
        </Typography>
      </div>
      <div>
        <Typography variant="h5">{getTranslate('Type')}</Typography>
      </div>
      <div>
        <IconButton>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default PoliciesFormAvailablePoliciesListTableHead
